/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const UsersEnum = {
    PUT_USERS_EDIT: '/userManagement',
    POST_USERS_ADD: '/userManagement',
    DELETE_USER: (username: string): string => {
        return '/userManagement/' + username;
    },
    DISABLE_USER: '/userManagement/api-test-test/disable',
    ENABLE_USER: '/userManagement/api-test-test/enable',
    GET_USERS_ALL: '/userManagement'
};
